var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M15.96 3.449a2.1 2.1 0 0 0-.576-1.077 2.1 2.1 0 0 0-1.485-.616H2.1a2.09 2.09 0 0 0-1.628.774 2.1 2.1 0 0 0-.432.92A2 2 0 0 0 0 3.857v8.286q0 .434.175.836a2.1 2.1 0 0 0 .585.782c.376.312.853.483 1.341.483H13.9a2.1 2.1 0 0 0 1.485-.616q.274-.273.43-.62l.014-.033a2.1 2.1 0 0 0 .172-.832V3.857q0-.206-.04-.408M1.089 3.097a1.261 1.261 0 0 1 1.013-.51H13.9a1.25 1.25 0 0 1 1.011.507l.09.121-6.296 5.488a1.07 1.07 0 0 1-1.407 0L1.006 3.217zm-.252 9.119a1 1 0 0 1-.004-.073V4.029l4.886 4.263-4.837 4.217zm13.692 1.029c-.189.11-.407.167-.63.167H2.102a1.26 1.26 0 0 1-.63-.167l-.197-.115 4.998-4.355.548.476a1.8 1.8 0 0 0 2.362 0l.548-.476 4.996 4.356zm.64-1.102q.001.038-.004.072l-.043.296-4.84-4.217 4.887-4.263z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.58f3cb62c11a300f7596ece3b9278b62.svg";
export { ForwardRef as ReactComponent };